import React,{useState,useContext, useRef} from 'react'
import '../getestimate2/getestimate.css'
import { Link, useNavigate } from 'react-router-dom'
import { wallframe } from '../assest/Exportimage'
import axios from '../../axios'
import Toast from '../../Toast'
import { AuthContext } from '../../AuthProvider'
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

const GetEstimate = () => {
  //const inputRef = useRef();
  const navigate = useNavigate()
  const {userToken,setEnquiry_id} = useContext(AuthContext)
  const [date,setDate] = useState("")
 const [bhk,setBhk] = useState("")
 const [from_location,setFrom_location] = useState("")
 const [to_location,setTo_location] = useState("")
 const [isLoading,setIsLoading] = useState("")


 const addorder=async(e)=>{
    
  e.preventDefault();

  if(!bhk || !date || !from_location || !to_location) {
    return Toast("please fill all details")
    
  } 
 
  try{
   setIsLoading(true)
   const response= await axios({
     method: "post",
    url:'/add-order',
     data:{
       bhk,date,
       from_location:from_location?.value?.description,
       to_location:to_location?.value?.description
     },
     headers:{
      'Authorization': `Bearer ${userToken}`
     }
     } )
     
    if(response.status===200){
     const data = response.data;
     Toast(data.message,response.status)
     window.localStorage.setItem('enquiry_id', JSON.stringify(data?.enquery_id));
     setEnquiry_id(data?.enquery_id)
     navigate('/getestimate2',{state:{id:data?.enquery_id}})
     
    }
  }
  catch(err){
   const error = err.response.data
   Toast(error.message);
   


  }
  finally{
   setIsLoading(false)
  } 
}
  

 
console.log("from....",from_location?.value?.description);
console.log("to....",to_location?.value?.description);

  return (
    <>
        <div className="section-marginX center-div">
<div className="getestimate">
<div className="getestimate-top">
  <img src={wallframe} style={{width: '100%'}}/>
</div>
<div className="getestimate-bottom center-div">
  <div >
    <p>I Am Shifting My </p>
    <select className="getestimate-input" value={bhk} onChange={e=>setBhk(e.target.value)}>
    <option selected hidden >Select BHK</option>
    <option value='1'>1BHK</option>
    <option value='2'>2BHK</option>
    <option value='3'>3BHK</option>
    <option value='4'>Villa</option>
    <option value='5'>Duplex</option>
    </select>
    <p>From</p>
    {/* <HeadShake spy={spy}>
    <input className="getestimate-input" placeholder='Apartment Name/Locality' style={{minWidth: '230px'}} value={from_location} onChange={e=>setFrom_location(e.target.value)}  />
    </HeadShake> */}

    {/* react-googl-map api input1 */}
    <div style={{width:'240px'}}>
    <GooglePlacesAutocomplete 
      apiKey='AIzaSyDu7neoVRZ_kqsYOEWXM2zCYReUYJgw2Ds'
       selectProps={{
        from_location,
        onChange:setFrom_location,
        placeholder:"Enter Address",
          className:'autocomplete'
       }}
    />
    </div>

    
    {/* react-googl-map api input1 end */}
  </div>

  <div >
    <p>To</p>
    {/* <HeadShake spy={spy}>
    <input className="getestimate-input" placeholder='Apartment Name/Locality' style={{minWidth: '230px'}} value={to_location} onChange={e=>setTo_location(e.target.value)} />
    </HeadShake> */}

 {/* react-googl-map api input1 */}
 <div style={{width:'240px'}}>
    <GooglePlacesAutocomplete 
      apiKey='AIzaSyDu7neoVRZ_kqsYOEWXM2zCYReUYJgw2Ds'
       selectProps={{
        to_location,
        onChange:setTo_location,
        placeholder:"Enter Address",
        className:'autocomplete'
       }}
    />
    </div>
    {/* react-googl-map api input1 end */}

    <p>On</p>
    <input type="datetime-local" id="meeting-time" className='getestimate-input'
       name="meeting-time" value={date} onChange={(e)=>setDate(e.target.value)}
       min="" max=""/>
    
  </div>

  <div  style={{ width:'300px'}}> 
  <button   className="getestimate-btn link-a" onClick={addorder}> Next </button>
 
  </div>
  <Link to="/rooms" className="lighptgrey-p link-a" style={{cursor:'pointer'}}>Previous enquiry </Link>
</div>


</div>
</div>
    </>
  )
}

export default GetEstimate
